import { render, staticRenderFns } from "./EhrContextBanner.vue?vue&type=template&id=781d3cce&scoped=true&lang=pug"
import script from "./EhrContextBanner.vue?vue&type=script&lang=js"
export * from "./EhrContextBanner.vue?vue&type=script&lang=js"
import style0 from "./EhrContextBanner.vue?vue&type=style&index=0&id=781d3cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d3cce",
  null
  
)

export default component.exports